module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学生请假",
      "width": "880"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型："
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.showModal.showModel),
      callback: function($$v) {
        _vm.$set(_vm.showModal, "showModel", $$v)
      },
      expression: "showModal.showModel"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("请单节课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("请长假")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("申请停课")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [(_vm.showModal.showModel == 1) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择课程：",
      "prop": "status"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.showModal.id),
      callback: function($$v) {
        _vm.$set(_vm.showModal, "id", $$v)
      },
      expression: "showModal.id"
    }
  }, _vm._l((_vm.userLessonOpend), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.stringLsnTime) + " " + _vm._s(item.lessonTitle))])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showModal.showModel == 2 || _vm.showModal.showModel == 3) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间",
      "value": _vm.leaveParam.startTimeStr
    },
    on: {
      "on-change": _vm.startTimeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间",
      "value": _vm.leaveParam.endTimeStr
    },
    on: {
      "on-change": _vm.endTimeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.onBookLessonOpened
    }
  }, [_vm._v("查看涉及课节")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showModal.showModel == 2 || _vm.showModal.showModel == 3) ? _c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-037f4932","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserLeaveModal.vue
// module id = 1611
// module chunks = 8